module.exports = __webpack_public_path__ + "static/media/contact-sos.cdf6cd68.png";